var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-flex',{staticClass:"navs",attrs:{"row":"","j-center":"","a-center":""}},_vm._l((_vm.navs),function(item){return _c('a',{key:item.key,staticClass:"item",style:(_vm.getStyles(item)),attrs:{"href":item.to},on:{"click":function($event){$event.preventDefault();return _vm.goto(item)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }